import { render, staticRenderFns } from "./resource-table.vue?vue&type=template&id=3e9289dd&scoped=true&"
import script from "./resource-table.ts?vue&type=script&lang=ts&"
export * from "./resource-table.ts?vue&type=script&lang=ts&"
import style0 from "./resource-table.scss?vue&type=style&index=0&id=3e9289dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9289dd",
  null
  
)

export default component.exports